"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _SimpleDialog = _interopRequireDefault(require("lead-flows-ui/components/common/SimpleDialog"));

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var PublishModal =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PublishModal, _PureComponent);

  function PublishModal() {
    (0, _classCallCheck2.default)(this, PublishModal);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PublishModal).apply(this, arguments));
  }

  (0, _createClass2.default)(PublishModal, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.secondaryNavigation." + suffix;
    }
  }, {
    key: "getConfigName",
    value: function getConfigName() {
      var _this$props = this.props,
          primaryCTA = _this$props.primaryCTA,
          saving = _this$props.saving,
          savingHasError = _this$props.savingHasError,
          scriptLoaderIsInstalled = _this$props.scriptLoaderIsInstalled,
          hasSaved = _this$props.hasSaved;

      if (saving) {
        return 'saving';
      } else if (hasSaved && savingHasError) {
        return 'savingError';
      } else if (hasSaved && !scriptLoaderIsInstalled) {
        return 'scriptNotInstalled';
      } else if (hasSaved) {
        return null;
      } else if (primaryCTA) {
        return primaryCTA;
      }

      return 'publish';
    }
  }, {
    key: "getConfig",
    value: function getConfig(config) {
      var modalConfig = {
        saving: {
          header: 'saving',
          content: this.renderSavingContent(),
          confirmDisabled: true,
          primaryButton: 'saving'
        },
        savingError: {
          header: 'error',
          content: this.renderSavingErrorContent(),
          confirmDisabled: false,
          primaryButton: this.langKey('fixErrors')
        },
        scriptNotInstalled: {
          cssClass: 'no-script',
          content: this.renderScriptNotInstalledContent(),
          confirmDisabled: false,
          contextual: true,
          use: 'success',
          size: 'short',
          primaryButton: this.langKey('noScript.button')
        },
        schedule: {
          header: this.langKey('schedule'),
          content: this.renderQuestion('schedule'),
          confirmDisabled: false,
          primaryButton: this.langKey('schedule'),
          secondaryButton: this.langKey('haveEdits')
        },
        unschedule: {
          header: this.langKey('unschedule'),
          content: this.renderQuestion('unschedule'),
          confirmDisabled: false,
          primaryButton: this.langKey('unschedule'),
          secondaryButton: this.langKey('haveEdits')
        },
        update: {
          header: this.langKey('update'),
          content: this.renderQuestion('update'),
          confirmDisabled: false,
          primaryButton: this.langKey('update'),
          secondaryButton: this.langKey('haveEdits')
        },
        publish: {
          header: this.langKey('readyToLaunch'),
          content: this.renderQuestion('publish'),
          confirmDisabled: false,
          primaryButton: this.langKey('setItLive'),
          secondaryButton: this.langKey('haveEdits')
        }
      };
      return config ? modalConfig[config] : null;
    }
  }, {
    key: "renderSavingContent",
    value: function renderSavingContent() {
      return _react.default.createElement(_UILoadingSpinner.default, {
        grow: true,
        minHeight: 50
      });
    }
  }, {
    key: "renderSavingErrorContent",
    value: function renderSavingErrorContent() {
      var _this$props2 = this.props,
          validation = _this$props2.validation,
          savingRecentError = _this$props2.savingRecentError;
      var validationName = savingRecentError && savingRecentError.status === 412 ? 'leadFlows.error.concurrentUpdates' : (0, _ValidationUtils.getValidationErrorKey)(validation);
      var customError = (0, _ValidationUtils.maybeShowInvalidMessage)(validationName);
      return _react.default.createElement("div", {
        className: "leadinModal__error-message"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: this.langKey('changesNotSaved')
      }), _react.default.createElement("br", null), customError ? _react.default.createElement("span", {
        className: "leadinModal__error-custom-message"
      }, customError) : null);
    }
  }, {
    key: "renderScriptNotInstalledContent",
    value: function renderScriptNotInstalledContent() {
      return _react.default.createElement("div", {
        className: "leadinModal__script-not-installed-message"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: this.langKey('noScript.header')
      }));
    }
  }, {
    key: "renderQuestion",
    value: function renderQuestion(key) {
      return _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey(key + "Modal.question"),
        className: "leadinModal__" + key
      });
    }
  }, {
    key: "renderFormatedMessage",
    value: function renderFormatedMessage(key) {
      return key ? _react.default.createElement(_FormattedMessage.default, {
        message: key
      }) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          showModal = _this$props3.showModal,
          handleConfirm = _this$props3.handleConfirm,
          handleReject = _this$props3.handleReject;
      var config = this.getConfig(this.getConfigName());

      if (!showModal || !config) {
        return null;
      }

      return _react.default.createElement(_SimpleDialog.default, {
        className: "leadinModal__container leadinModal-icon__container " + config.cssClass,
        contextual: config.contextual || false,
        headerText: this.renderFormatedMessage(config.header),
        use: config.use,
        size: config.size,
        confirmDisabled: config.confirmDisabled,
        primaryText: this.renderFormatedMessage(config.primaryButton),
        secondaryText: this.renderFormatedMessage(config.secondaryButton),
        onConfirm: handleConfirm,
        onReject: handleReject
      }, _react.default.createElement("div", {
        className: "leadinModal__body"
      }, config.content));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        showModal: _react.PropTypes.bool.isRequired,
        primaryCTA: _react.PropTypes.string.isRequired,
        hasSaved: _react.PropTypes.bool.isRequired,
        saving: _react.PropTypes.bool.isRequired,
        savingHasError: _react.PropTypes.bool.isRequired,
        scriptLoaderIsInstalled: _react.PropTypes.bool.isRequired,
        validation: _react.PropTypes.object,
        handleConfirm: _react.PropTypes.func.isRequired,
        handleReject: _react.PropTypes.func.isRequired,
        savingRecentError: _react.default.PropTypes.object
      };
    }
  }]);
  return PublishModal;
}(_react.PureComponent);

exports.default = PublishModal;
module.exports = exports.default;